export type ExplorerSort = { column: string; order: 'asc' | 'desc' }

/**
 * Multi-sort is encoded into the single `sort` URL/preset string as
 * comma-separated `column:desc` entries (`:asc` omitted), e.g.
 * `updated_at:desc,name`. Legacy single-sort state (`sort=col&order=desc`)
 * still parses via the `legacyOrder` argument.
 */
export function parseExplorerSort(sort: unknown, legacyOrder?: unknown): ExplorerSort[] {
  const raw = typeof sort === 'string' ? sort : ''
  const parts = raw.split(',').map(s => s.trim()).filter(Boolean)
  const sorts: ExplorerSort[] = []
  for (const part of parts) {
    const m = part.match(/^(.+?):(asc|desc)$/i)
    if (m) {
      sorts.push({ column: m[1].trim(), order: m[2].toLowerCase() === 'desc' ? 'desc' : 'asc' })
    } else {
      sorts.push({ column: part, order: 'asc' })
    }
  }
  if (sorts.length === 1 && !raw.includes(':') && legacyOrder === 'desc') {
    sorts[0] = { ...sorts[0], order: 'desc' }
  }
  return sorts
}

export function serializeExplorerSort(sorts: ExplorerSort[]): string {
  return sorts
    .filter(s => s.column.trim())
    .map(s => (s.order === 'desc' ? `${s.column.trim()}:desc` : s.column.trim()))
    .join(',')
}
